<template>
  <div class="body">
    <div class="title">
      帖子审核
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item>帖子审核</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <button size="medium" class="btn"  @click="shenhetongguo">
          <i class="el-icon-check"></i>
          批量通过</button>
        <div class="switch">
          <div class="titsss">
            人工审核
          </div>
          <el-switch
            v-model="isStatuscc"
            :inactive-value = 1
            :active-value = 0
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="openrengongshenhe($event)"
          >
          </el-switch>
            <div :style="{'color': (isStatuscc === 1 ? '#cccccc':'#0FA838')}" class="size">
              {{isStatuscc ===0 ?'开启':'关闭'}}
            </div>
        </div>
      </div>
      <div style="flex: 1"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="申请日期"
              v-model="Query.create_date"
              @change="Discountsearch">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-cascader :props="checkedData.typeOptions" @change="changList" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="发布板块" v-model="Query.types"  @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
              <el-option
                v-for="item in optiontype"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="审核状态" v-model="Query.verify_status" @change="Discountsearch"   style="min-width: 168px;width: 168px" clearable>
              <el-option
                v-for="item in shenheTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 " style="min-width: 168px;width: 336px;" v-model="Query.keyword" @input="Discountsearch">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :stripe="true"
      :data="tableData"
      ref="EditUsertable"
      @selection-change="EdithandleSelectionChange"
      align="center"
      max-height="750"
      class="mytable-scrollbar"
      :row-key="(row) => row.user_id">
      <el-table-column
        type="selection"
        :reserve-selection="true"
      >
      </el-table-column>
      <el-table-column type="seq" width="60"></el-table-column>
      <el-table-column prop="typename" label="发布板块"></el-table-column>
      <el-table-column prop="name" label="发布标题"></el-table-column>
      <el-table-column prop="realname" label="发布者"></el-table-column>
      <el-table-column prop="mobile" label="联系电话"></el-table-column>
      <el-table-column prop="addtime" label="发布时间"></el-table-column>
      <el-table-column  label="帖子状态">
        <template  slot-scope="scope">
          <span v-if="scope.row.verify_status === 0" class="daitongguo">待通过</span>
          <span v-if="scope.row.verify_status === 2" class="weizhiding">未通过</span>
          <span v-if="scope.row.verify_status === 1" class="yizhiding">已通过</span>
        </template>
      </el-table-column>
      <el-table-column  label="置顶状态">
        <template  slot-scope="scope">
          <span v-if="scope.row.is_top === 0" class="weizhiding">未置顶</span>
          <span v-if="scope.row.is_top === 1" class="yizhiding">置顶(剩余{{scope.row.istop_surplusdays}}天)</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="200" style="text-align: center">
        <template slot-scope="scope">
          <div class="row">
            <button  size="mini" @click="chakanxiangqing(scope.row)" class="chakanxiangqing" >查看详情</button>
            <button  size="mini" @click="itemshenhe(scope.row)" class="tongguo" v-if="scope.row.verify_status === 0">通过审核</button>
            <button  size="mini" @click="itemjujue(scope.row)" class="jujue" v-if="scope.row.verify_status === 0">拒绝通过</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15,20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <vxe-modal  width="336" ref="tongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClose">
        <div class="titledd">
          是否确认通过申请?
        </div>
        <div class="bobox">
          <button class="queren" @click="openqueren">
            确认
          </button>
          <button class="quxiao"  @click="routeClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal  width="336" ref="jujue" height="202" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClosecc">
        <div class="titledd mbP">
          是否拒绝通过申请?
        </div>
        <vxe-input v-model="remark" placeholder="请输入拒绝理由"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openjujue">
            确认
          </button>
          <button class="quxiao"  @click="routeClosecc">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>

import { postsetstatus, postStatusview, tieziliebiao, postSetverifystatus } from '@/api/tiezi'
import { city, province } from '@/api/city'

export default {
  name: 'index',
  data () {
    return {
      cur_page: 1,
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad
        }
      },
      shenheTypes: [
        {
          value: '0',
          label: '全部 '
        },
        {
          value: '1',
          label: '未审核 '
        },
        {
          value: '2',
          label: '已审核 '
        },
        {
          value: '3',
          label: '拒绝 '
        }
      ],
      optiontype: [
        {
          value: '0',
          label: '全部 '
        }, {
          value: '1',
          label: '二手转让'
        },
        {
          value: '2',
          label: '供需大厅'
        },
        {
          value: '3',
          label: '招商加盟'
        },
        {
          value: '4',
          label: '求租求购'
        },
        {
          value: '5',
          label: '房产中介'
        },
        {
          value: '6',
          label: '人才招聘'
        }
      ],
      zhidingQuery: {},
      pageshow: true,
      query: {},
      tableData: [],
      isStatuscc: 0,
      total: null,
      remark: '',
      Query: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        province_id: 0,
        city_id: 0,
        types: null,
        verify_status: null,
        keyword: '',
        page: 1,
        pagesize: 10,
        total: null,
        NewArr: null,
        orach: null
      }
    }
  },
  created () {
    this.zhuangtaichakan()
    this.tiezicc()
  },
  computed: {
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  methods: {
    changList (val) {
      this.Query.province_id = val[0]
      this.Query.city_id = val[1]
      this.Discountsearch()
    },
    async lazyLoad (node, resolve) {
      const level = node.level
      let result
      let res
      let param
      switch (level) {
        case 0: // 一级
          res = await province()
          result = res.data.list
          result.forEach((item) => {
            item.value = item.province_id
            item.label = item.province_name
          })
          break
        case 1: // 二级
          console.log(node.data.province_id)
          param = {
            province_id: node.data.province_id
          }
          res = await city(
            param
          )
          result = res.data.list
          // console.log(result)
          result.forEach((item) => {
            item.value = item.city_id
            item.label = item.city_name
            item.leaf = level >= 1
          })
          break
        // case 2: // 三级目录
        //   console.log(node.data.city_id)
        //   param = {
        //     city_id: node.data.city_id
        //   }
        //   res = await area(
        //     param
        //   )
        //   result = res.data.list
        //   result.forEach((item) => {
        //     item.value = item.area_id
        //     item.label = item.area_name
        //     item.leaf = level >= 2
        //   })
        //   break
        // case 3: // 三级目录
        //   param = {
        //     area_id: node.data.area_id
        //   }
        // res = await getStreet(
        //   param
        // )
        // result = res.list
        // result.forEach((item) => {
        //   item.value = item.street_id
        //   item.label = item.short_name
        //   // 大于三级后不再显示后面的，到此结束
        //   item.leaf = level >= 3
        // })
        // break
        default:
          result = []
          break
      }
      console.log(result)
      resolve(result)
    },
    chakanxiangqing (row) {
      console.log(row)
      this.$store.commit('setfabuID', row.id)
      this.$router.push('/tiezichakanxiangqing')
    },
    handleSizeChange (val) {
      this.Query.pagesize = val
      this.handleCurrentChange(this.Query.page)
    },
    handleCurrentChange (val) {
      this.Query.page = val
      const obj = {
        token: sessionStorage.getItem('token'),
        create_date: this.Query.create_date,
        province_id: this.Query.province_id,
        city_id: this.Query.city_id,
        types: this.Query.types,
        verify_status: this.Query.verify_status,
        keyword: this.Query.keyword,
        page: this.Query.page,
        pagesize: this.Query.pagesize,
        total: this.Query.total
      }
      tieziliebiao(obj).then(({ data: res }) => {
        console.log('rescc', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    openjujue () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.orach,
        apply_type: 2,
        apply_remark: this.remark
      }
      postSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.jujue.close()
          this.tiezicc()
        }
      })
    },
    routeClosecc () {
      this.$refs.jujue.close()
    },
    itemjujue (row) {
      this.orach = row.id
      this.$refs.jujue.open()
    },
    tiezicc () {
      tieziliebiao(this.Query).then(({ data: res }) => {
        console.log('rescc', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    zhuangtaichakan () {
      const obj = {
        token: sessionStorage.getItem('token')
      }
      postStatusview(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.audit_status === 0) {
          this.isStatuscc = 0
        } else if (res.audit_status === 1) {
          this.isStatuscc = 1
        }
        //  audit_status 1 关闭 0开启
      })
    },
    itemshenhe (row) {
      this.orach = row.id
      this.$refs.tongguo.open()
    },
    shenhetongguo () {
      this.$refs.tongguo.open()
    },
    routeClose () {
      this.$refs.tongguo.close()
    },
    openqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.orach,
        apply_type: 1
      }
      postSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.tongguo.close()
          this.tiezicc()
        }
      })
    },
    Discountsearch () {
      this.Query.page = 1
      this.cur_page = 1
      this.tiezicc()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    EdithandleSelectionChange (val) {
      console.log('val', val)
      const Arr = []
      val.forEach(i => {
        Arr.push(i.id)
        this.NewArr = [...new Set(Arr)]
        console.log('NewArr', this.NewArr)
        console.log(JSON.stringify(this.NewArr).replace(/\[|]/g, ''))
        this.orach = JSON.stringify(this.NewArr).replace(/\[|]/g, '')
      })
    },
    openrengongshenhe (e) {
      console.log('eee', e)
      this.isStatuscc = e
      console.log(' this.isStatuscc', this.isStatuscc)
      const obj = {
        token: sessionStorage.getItem('token'),
        is_status: this.isStatuscc
      }
      postsetstatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
        }
      })
    }
  }
}
</script>

<style  lang="less">
.el-scrollbar__wrap{
  height: 200px ;
}
.el-table th:nth-child(10 )>.cell {
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  text-align: center;
}
.row{
  display: flex;
  flex-direction: row;
  align-items: center;
  .chakanxiangqing{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    background: white;
    margin-right: 16px;
  }
  .tongguo{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(15,168,56,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #0fa838;
    letter-spacing: 0px;
    background: white;
    margin-right: 16px;
  }
  .jujue{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(229,72,72,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #e54848;
    letter-spacing: 0px;
  }
}
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.tongguo{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #0fa838;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.jujue{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #e54848;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.rou{
  display:flex;
  flex-direction: row;
  align-items: center;
}
.sdbutton{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.weitongguo{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #e54848;
  letter-spacing: 0px;
}
.daitongguo{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #f7d05c;
  letter-spacing: 0px;
}
.weizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: red;
  letter-spacing: 0px;
}
.yizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.imgs{
  width: 45px;
  height: 45px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 50%;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      margin-right: 150px;
      display:flex;
      align-items: center;
      .switch{
        display: flex;
        flex-direction: row;
        align-items: center;
        .titsss{
          min-width: 80px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          text-align: left;
          color: #2e2e2e;
          letter-spacing: 0px;
          margin-right: 11px;
        }
        .size{
          min-width: 20px;
          margin-left: 10px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: left;
          letter-spacing: 0px;
        }
      }
      .btn{
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border: none;
        margin-right: 19px;
      }
    }
    .right{
      margin-top: 27px;
    }
  }
}
</style>
